import type { TrendingHashtagsResponseHashtagsItem } from './trendingHashtagsResponseHashtagsItem';

export interface TrendingHashtagsResponse {
  hashtags?: TrendingHashtagsResponseHashtagsItem[];
  updatedAt?: string;
}
